import { Heart, Mic, PenLine, Compass } from "lucide-react";
import { ADVOCACY, ADVOCACY_IMAGE } from "../../data/mock";

const PILLAR_ICONS = [Mic, PenLine, Compass];

export default function Advocacy() {
  return (
    <section
      id="advocacy"
      data-testid="advocacy-section"
      className="py-24 md:py-32 bg-cream-alt"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="eyebrow" data-testid="advocacy-eyebrow">Advocacy</span>
            <h2
              data-testid="advocacy-heading"
              className="font-display text-4xl md:text-5xl lg:text-[52px] leading-[1.05] mt-6 text-navy"
            >
              {ADVOCACY.title.split("for")[0]}for
              <br />
              <span className="italic text-terracotta">invisible illness.</span>
            </h2>

            <div className="mt-8 relative">
              <div
                className="absolute -top-4 -left-4 w-full h-full border-[1.5px] border-terracotta"
                aria-hidden="true"
              />
              <img
                src={ADVOCACY_IMAGE}
                alt="Soft organic floral abstraction"
                data-testid="advocacy-image"
                className="relative w-full h-[300px] md:h-[380px] object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <p
              data-testid="advocacy-body"
              className="text-xl md:text-[22px] text-navy leading-relaxed font-display"
            >
              {ADVOCACY.body}
            </p>

            <div className="mt-12 space-y-4">
              {ADVOCACY.pillars.map((p, i) => {
                const Icon = PILLAR_ICONS[i];
                return (
                  <div
                    key={i}
                    data-testid={`advocacy-pillar-${i}`}
                    className="flex gap-5 p-6 bg-cream border border-[#E5E0D8] hover:border-terracotta transition-colors"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-terracotta text-cream flex items-center justify-center">
                      <Icon size={22} strokeWidth={1.6} />
                    </div>
                    <div>
                      <h3 className="font-display text-2xl text-navy">{p.title}</h3>
                      <p className="text-ink-muted mt-1.5 text-[17px] leading-relaxed">
                        {p.text}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-10 flex items-center gap-3 text-sm text-ink-muted">
              <Heart size={16} className="text-terracotta" />
              <span>Living with AuDHD &amp; Ehlers-Danlos Syndrome — and writing openly about both.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
